/**
 * Datasource management utility.
 * Store, retrieve, and modify datsource definitions using simple placeholders for dynamic parameters.  Placeholders can be configured with default values inline.
 * @name datasource-manager
 * @type {Object}
 */
define('datasource-manager/datasource-manager',['require','exports','module','./lib/extend','./lib/Datasource','data-transformers/xml-to-json'],function(require,exports,module){
	var extend = require('./lib/extend'),
		Datasource=require('./lib/Datasource'),
		xmlToJson=require('data-transformers/xml-to-json');

	var UNDEF, 			
		EMPTY			= "",
		FUNCTION 		= "function",
		STRING 			= "string",
		OBJECT 			= "object",
		dscache			= {},

		/**
		 * Collection of configured datasources.
		 * @example : 
		 * 	
		 *
		 * @private
		 * @type {Object}
		 */
		_datasources = {
			"defaults" : {
				"namespace"   : "default",
				"expires"     : 300,  
				"timeout"     : 20,
				"retries"     : 1,
				"priority"    : 2,
				"transformer" : xmlToJson,
				"mimetype"    : "text/xml",
				"method"      : "GET"
			}
		};

		/** Public API **/
	return {
		/**
		 * Add one or more datasource definitions.
		 * @param {mixed}	name    Datasource name or a collection of 
		 *                        	definitions.
		 * @param {object} 	[options] If name is a string, options is a required
		 *                            set of properties.
		 * @return {boolean} Returns true if operation is successful.
		 */
		add : function(name, options){
			if(typeof name===OBJECT){
				extend(_datasources, name); //multiple sources
				return true;
			}
			if(_datasources[name]){
				return false;
			}
			_datasources[name]=options||{};
			return true;
		},

		/**
		 * Remove a single datasource definition.
		 * @param {string}	name    Name of the datasource to be removed.
		 *                            set of properties.
		 * @return {boolean} Returns true if operation is successful.
		 */
		remove : function(name){
			var datasource=_datasources[name];
			delete _datasources[name];
			delete dscache[name];
			
			return datasource;
		},

		/**
		 * Update an existing datasource definition.
		 * @param  {string} name Name of datasource to update.
		 * @param  {object} obj  Set of properties to override.
		 */
		update : function(name, obj){
			if(_datasources[name]){
				extend(_datasources[name], obj);
			}
				// Delete previously cached compiled version if present.
			delete dscache[name];
		},
		/**
		 * Get a all available datasources as a collection.
		 * @return {object}
		 */
		getAll : function(){
			return _datasources;
		},
		/**
		 * Retrieve a single datasource, merge it's properties with defaults and return.
		 * @param  {string}	dataSourceName Datasource name to retrieve.
		 * @return {[type]}                [description]
		 */
		get : function(dataSourceName) {
			if(_datasources[dataSourceName]){
				return dscache[dataSourceName]=dscache[dataSourceName]||new Datasource(dataSourceName,_datasources);	
			}
			return new Datasource("datasource '"+dataSourceName+"' not found",_datasources);
		},

		Datasource : Datasource
	};

});
